import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import {
    HarvestEventHarvestPickTypeId,
    HarvestEventPickTypeName,
    HarvestEventsProps
} from 'services/harvestEvents/types';

// Global Components
import PickTypeNameValue from 'components/PickTypeNameValue';

// Global Selectors
import {
    makeSelectHarvestEventPickTypeName,
    makeSelectHarvestEventHarvestPickTypeId
} from 'services/harvestEvents/selectors';

type OwnProps = HarvestEventsProps;

interface ConnectedProps {
    pickTypeId: HarvestEventHarvestPickTypeId;
    pickTypeName?: HarvestEventPickTypeName;
}

type Props = OwnProps & ConnectedProps;

export class HarvestEventPickTypeNameValue extends React.PureComponent<Props> {
    render(): string | React.ReactElement | null {
        const { pickTypeId, pickTypeName } = this.props;
        if (pickTypeName) {
            return pickTypeName;
        }

        if (pickTypeId) {
            return <PickTypeNameValue pickTypeId={pickTypeId} />;
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    pickTypeId: makeSelectHarvestEventHarvestPickTypeId(),
    pickTypeName: makeSelectHarvestEventPickTypeName()
});

export default connect(mapStateToProps)(HarvestEventPickTypeNameValue);
